export const AdsPph23RefundRBAC = {
  pageID: '7833487f284221c8cb7173b9931df240',
  elementID: {
    ViewPph23RefundTable: '4348121b9854b47b00d4120574bcf08a',
  },
} as const
